import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ApplyChangesComponent } from './apply-changes.component';
import { RnplCommonModule } from 'common/src/modules';


@NgModule({
  declarations: [
    ApplyChangesComponent
  ],
  exports: [
    ApplyChangesComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RnplCommonModule
  ],
})
export class ApplyChangesModule { }
